import { RulesRenewBase } from './rules-renew.class';

export class RulesRenewPremiumBase extends RulesRenewBase {
    public KEY: string = 'renewPremium';
}
